import { render, staticRenderFns } from "./externalUserDetail.vue?vue&type=template&id=d0bbd64a"
import script from "./externalUserDetail.vue?vue&type=script&lang=js"
export * from "./externalUserDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports